window.hoculus = window.hoculus || {};
if (console && console.log) {
	console.log(
		"Coded by %cHoculus srl %con %cShopify %c- %c" +
		Shopify.theme.name +
		" %c -> https://hoculus.com",
		"color: red; font-weight: bold",
		"color: unset",
		"color: green",
		"color: unset",
		"color: blue",
		"color: unset; font-weight: bold"
	);
}

hoculus.utils = class {
    
    static async domreadyState() {
		return await new Promise(function (resolve, reject) {
			document.onreadystatechange = () => {
				if (document.readyState === "complete") {
					resolve(true);
				}
			};
		});
	}

	static waitForInteraction(events) {
        const interactionEvents = events ?? [
            "click",
            "keydown",
            "mousemove",
            "touchstart",
            "scroll"
        ]; // Use default events if none are provided

        return new Promise(resolve => {
            // Add event listeners for interaction events
            interactionEvents.forEach(event => {
                window.addEventListener(event, resolve, { once: true });
            });
        });
    }

	static async getScriptAsync(source, { isModule = false, isNoModule = false } = {}) {
        return await new Promise(function (resolve, reject) {
            hoculus.loadedScripts = hoculus.loadedScripts || [];
            if (hoculus.loadedScripts.includes(source) || source == "") {
                resolve(true);
            } else {
                var script = document.createElement("script");
                var prior = document.getElementsByTagName("script")[0];

                script.defer = 1;

                if (isModule) script.type = "module";
                if (isNoModule) script.noModule = 1;

                script.onload = script.onreadystatechange = function (_, isAbort) {
                    if (
                        isAbort ||
                        !script.readyState ||
                        /complete/.test(script.readyState)
                    ) {
                        script.onload = script.onreadystatechange = null;
                        script = undefined;

                        if (!isAbort) setTimeout(resolve(true), 50);
                    }
                };

                script.src = source;
                prior.parentNode.insertBefore(script, prior);
            }
        });
    }

    static async getCssAsync(source) {
        return await new Promise(function (resolve, reject) {
            hoculus.loadedStyles = hoculus.loadedStyles || [];
            if (hoculus.loadedStyles.includes(source) || source == "") {
                resolve(true);
            } else {
                var link = document.createElement("link");
                var prior = document.getElementsByTagName("link")[0] || document.getElementsByTagName("head")[0].firstChild;

                link.rel = "stylesheet";
                link.href = source;

                link.onload = link.onreadystatechange = function (_, isAbort) {
                    if (
                        isAbort ||
                        !link.readyState ||
                        /complete/.test(link.readyState)
                    ) {
                        link.onload = link.onreadystatechange = null;
                        link = undefined;

                        if (!isAbort) setTimeout(resolve(true), 50);
                    }
                };

                prior.parentNode.insertBefore(link, prior);
            }
        });
    }
	
}


hoculus.Clarity = class {
	constructor(id) {
		this.init(window, document, "clarity", "script", id);
	}

	init(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
	}
}


hoculus.utils.domreadyState().then(async () => {
	
	// ! ---- The code below will run after user interaction ----
	await hoculus.utils.waitForInteraction();

	// Init Clarity after interaction
	if (hoculus.globalSettings.clarity.isActive && window.Shopify.theme.role == 'main') new hoculus.Clarity('td7wfnmlw9');
});